import React from 'react'
import { ListItem } from '../styles'

interface TerminalsListItemProps {
  item: any
  bg?: string
}

const Item: React.FC<TerminalsListItemProps> = ({ item, bg = '#fff' }) => {
  return (
    item && (
      <>
        <ListItem bg={bg}>
        <div>{item.id}</div>
          <div>{'90%'}</div>
          <div>{'тест'}</div>
          <div>{'19300.10'}</div>
          <div>{'1300.10'}</div>
          <div>{'1800.00'}</div>
          <div>{'2'}</div>
          <div>{'1800.00'}</div>
        </ListItem>
      </>
    )
  )
}

export default Item
